export const favicon = 'images/favicon.ico';
export const title = 'Massimo Schembri | Personal Page';
export const meta = [
  {
    name: 'description',
    content: 'Peter Parker is a Computer Engineer, Photographer & Designer based in LA.'
  },
  {
    name: 'keywords',
    content: 'massimo,schembri,redhat,devops,kubernetes,ansible,platform,python'
  }
];
export const landingPage = 'about';
